import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0e35866"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "prependIcon h-100 px-2 pl-4 d-flex align-center"
}
const _hoisted_2 = ["value", "required", "type", "min", "max", "disabled", "placeholder"]
const _hoisted_3 = {
  key: 1,
  class: "appendIcon h-100 px-2 pe-4 d-flex align-center"
}
const _hoisted_4 = {
  key: 1,
  class: "error-msg"
}

import { computed, ref, withDefaults, useAttrs } from 'vue';
import omit from '@/utils/omit';
import { InputType } from '@/types';

// const { calcFieldSize } = useField()


const __default__ = {
  inheritAttrs: false,
};

interface InputProps {
  modelValue?: any;
  placeholder?: string;
  maxWidth?: string;
  alignInput?: string;
  mask?: string | string[] | any;
  list?: string;
  label?: string;
  msgError?: string;
  type?: InputType;
  maxLength?: number | string;
  minLength?: number | string;
  max?: number | string;
  min?: number | string;
  borderColor?: string;
  height?: string | number;
  filled?: boolean;
  simple?: boolean;
  selectionOnFocus?: boolean;
  noStyle?: boolean;
  prependIcon?: boolean;
  appendIcon?: boolean;
  noBgPrependIcon?: boolean;
  noBorderPrependIcon?: boolean;
  noBgAppendIcon?: boolean;
  disabled?: boolean;
  required?: boolean;
  hasError?: boolean;
  wFull?: boolean;
  borderBottom?: boolean;
  nullable?: boolean;
  trim?: boolean;
  classes?: string;
  sizeLabel?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AtomInput',
  props: {
    modelValue: { default: '' },
    placeholder: {},
    maxWidth: {},
    alignInput: { default: 'left' },
    mask: { default: '' },
    list: {},
    label: {},
    msgError: {},
    type: { default: 'text' },
    maxLength: { default: 126 },
    minLength: {},
    max: {},
    min: {},
    borderColor: { default: 'gray-500' },
    height: { default: 2.25 },
    filled: { type: Boolean, default: false },
    simple: { type: Boolean },
    selectionOnFocus: { type: Boolean },
    noStyle: { type: Boolean, default: false },
    prependIcon: { type: Boolean, default: undefined },
    appendIcon: { type: Boolean, default: undefined },
    noBgPrependIcon: { type: Boolean, default: false },
    noBorderPrependIcon: { type: Boolean, default: false },
    noBgAppendIcon: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean },
    hasError: { type: Boolean },
    wFull: { type: Boolean, default: false },
    borderBottom: { type: Boolean },
    nullable: { type: Boolean },
    trim: { type: Boolean },
    classes: { default: '' },
    sizeLabel: {}
  },
  emits: ["update:modelValue", "click", "keydown", "focus", "update:hint"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "332c6536": (_ctx.maxWidth)
}))

const props = __props;

const emit = __emit;
// const emit = defineEmits(['click', 'keydown', 'update:modelValue', 'focus', 'update:hint'])

const attrs = useAttrs();

const input = ref<HTMLInputElement | null>(null);

const listeners = computed(() => ({
  input: emitValue,
  keydown: processValue,
  blur: (e: Event) => {
    trimIfEnabled();
    if (typeof attrs.onBlur === 'function') attrs.onBlur(e);
  },
  focus: (e: PointerEvent) => emit('focus', e),
}));

const attributes = computed(() => omit(attrs, 'class'));

// const isStepUpAllowed = computed(() => {
//   return props.disabled === false && (props.max === undefined || parseInt(String(props.modelValue), 10) < props.max);
// });

// const isStepDownAllowed = computed(() => {
//   return props.disabled === false && (props.min === undefined || parseInt(String(props.modelValue), 10) > props.min);
// });

const processValue = (event: KeyboardEvent) => {
  if (!event.key) return;
  //   const key = event.key.toLocaleLowerCase()
  //   const systemKeys = ['meta', 'shift', 'alt', 'backspace', 'delete', 'tab']
  //   const value = (event.target as HTMLInputElement).value

  //   if (props.slug === true) {
  //   }

  //   if (props.dbSafe === true) {
  //   }

  emit('keydown', event);
};

const emitValue = (event: InputEvent) => {
  const value = (event.target as HTMLInputElement).value;

  if (props.nullable === true && value === '') {
    emit('update:modelValue', null);
    return;
  }

  if (props.type === 'number') {
    const parsedNumber = Number(value);

    if (props.modelValue !== parsedNumber) emit('update:modelValue', parsedNumber);
  } else {
    // if (props.slug === true) {
    // }

    // if (props.dbSafe === true) {
    // }

    emit('update:modelValue', value);
  }
};

const trimIfEnabled = () => {
  if (props.modelValue && props.trim && ['string', 'text'].includes(props.type))
    emit('update:modelValue', String(props.modelValue).trim());
};

// const stepUp = () => {
//   if (!input.value) return;
//   if (isStepUpAllowed.value === false) return;
//   input.value.stepUp();
//   if (input.value.value != null) return emit('update:modelValue', Number(input.value.value));
// };

// const stepDown = () => {
//   if (!input.value) return;
//   if (isStepDownAllowed.value === false) return;
//   input.value.stepDown();
//   if (input.value.value) return emit('update:modelValue', Number(input.value.value));
//   else return emit('update:modelValue', props.min || 0);
// };

return (_ctx: any,_cache: any) => {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes)
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          style: _normalizeStyle({fontSize: props.sizeLabel === 'lg'? '18px' : ''}),
          class: "mb-2"
        }, _toDisplayString(props.label), 5))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "input-wapper d-flex",
      style: _normalizeStyle({height: _ctx.height? _ctx.height : '40px' })
    }, [
      (_ctx.prependIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "prependIcon")
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", _mergeProps({
        value: props.modelValue,
        ref_key: "input",
        ref: input,
        required: _ctx.required
      }, attributes.value, {
        type: _ctx.type,
        min: _ctx.min,
        max: _ctx.max,
        disabled: _ctx.disabled
      }, _toHandlers(listeners.value, true), {
        placeholder: _ctx.placeholder,
        style: {textAlign: _ctx.alignInput}
      }), null, 16, _hoisted_2), [
        [_directive_maska, _ctx.mask]
      ]),
      (_ctx.appendIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "appendIcon")
          ]))
        : _createCommentVNode("", true)
    ], 4),
    (_ctx.hasError && _ctx.msgError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.msgError), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})